module.exports = __webpack_public_path__ + "img/symbol_12.5a6c7531.png";